<template>
<transition name="fade" appear>
  <div class="mh5-l ph3">
    <div class="fl w-100">
      <h1 class="page-header f4 f2-l">Profile</h1>
    </div>
    <div class="fl w-100 w-30-l flex flex-column">
      <!-- Profile section -->
      <div class="ma3-l mr3-l">
        <transition name="EnterFromAbove" appear>
          <core-user-settings/>
        </transition>
      </div>
      <!-- In Game Balance section -->
      <div class="flex flex-column mr3-l mr0-l">
        <div class="mb3 v-mid">
          <div class="pa0 bg-black-10 b1 ">
            <h2 class="ph2-l pv2 mb1 mt0 f5 f3-l fw3">In Game Balances</h2>
          </div>
          <div class="flex flex-column pa2-l f6 f5-l">
            <div class="flex flex-row items-center ph2-l pt2">
              <img src="@/assets/Coin_Halodium.png" class="dib token-icon v-mid relative" alt="Halodium Icon">
              <div>{{ 0 || addCommasAddThreeDecs(playerGameBalanceHALO) }}</div>
              <div class="pl2 fw1">HALO</div>
            </div>
            <div class="flex flex-row items-center ph2-l pt2 mv2">
              <img src="@/assets/ETHEREUM-ICON_Black_small.png" class="icon-eth dib token-icon v-mid relative" alt="Halodium Icon">
              <div>{{ 0 || addCommasAddThreeDecs(playerGameBalanceETH) }}</div>
              <div class="pl2 fw1">ETH</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fl w-100 w-70-l flex flex-row-l flex-column justify-center">
      <!-- Wallet section -->
      <div class="flex flex-column mh3-l w-100">
        <div class="bg-component mb3 v-mid">
          <div class="pa0 bb b--gray b1 ">
            <h2 class="ph2 mb1 mt0 f5 f3-l fw3">Wallet</h2>
          </div>
          <!-- Hide Wallet contents on mobile -->
          <div class="dn flex-l flex-column bb b--gray b1">
            <div class="tc fw1 pa2 bb b--gray b1">
              <img src="@/assets/Coin_Halodium.png" class="dib token-icon v-mid relative" alt="Halodium Icon">
              <span class="v-mid dib f5 white ">HALO Wallet Balance:
                <strong v-if="balance" class="dib">{{ addCommasAddThreeDecs(balance) }}</strong>
                <strong v-else class="dib">No Wallet</strong>
              </span>
            </div>
            <!-- If there is no wallet for the basic account, will the token balance be shown? What token will it be? -->
            <div class="flex flex-row items-center ph2 pt2">
              <template v-if="balance">
                <div class="flex flex-row items-center w-100">
                  <a class="w-40 dib no-underline grow v-mid ba cta-button-sm tc" href="https://dapp-wallet.haloplatform.tech/#/" target="_blank">Open Wallet</a>
                  <p class="silver w-60 f6">Open your HALO wallet in the Featherlite extension</p>
                </div>
              </template>
              <template v-else>
                <router-link class="w-40 no-underline grow dib v-mid ba cta-button-sm tc" to="/tutorial">Get a Wallet</router-link>
                <p class="silver w-60 f6">Create your own HALO wallet.</p>
              </template>
            </div>
            <div class="flex flex-row items-center ph2">
              <a class="w-40 dib no-underline grow v-mid ba cta-button-sm tc" href="http://halodex.io" target="_blank">Buy HALO</a>
              <p class="silver w-60 f6">This will take you to the <a href="https://halodex.io" class="link dim light-silver" target="_blank">HaloDex</a>, where you can purchase HALO. Please visit our <a href="https://wiki.haloplatform.tech/HaloDex" class="link dim light-silver">wiki page</a> on how to get started with HaloDex.</p>
            </div>
            <div v-if="balance" class="flex flex-row items-center ph2 pb2">
              <div @click="openCryptoCage" class="w-40 pointer dib no-underline grow v-mid ba cta-button-sm tc">Crypto Cage</div>
              <p class="w-60 f6 silver">Use the Crypto Cage to buy game coins with HALO or ETH.</p>
            </div>
          </div>
          <div class="dn db-l fw1 pa0 bg-black-20">
            <p v-if="balance" class="ma0 pa1 f7 v-mid silver">Wallet Address: <span class="f5">{{ coinbase }}</span><a @click.stop.prevent="copyAddress" v-tooltip="{content: 'Copy address to clipboard'}" href="#0" class="link dim pl2 silver"><i class="far fa-copy"></i></a><input type="hidden" id="wallet-address" :value="coinbase"></p>
          </div>
          <!-- Show on mobile, not desktop -->
          <div class="pa2 dn-l">
            <p>Sign in on a full desktop Chrome browser to view wallet information.</p>
          </div>
        </div>
      </div>
      <!-- Recent Game Activity -->
      <div class="fr w-100">
        <div class="flex flex-column content-stretch ml3-l mb3 pv1 bg-component achievement-container">
          <pc-achievements-recent-all />
        </div>
      </div>
    </div>

  </div>
</transition>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'profile',

  computed: {
    ...mapGetters({
      balance: 'webThree/balance',
      coinbase: 'webThree/coinbase',
      displayName: 'user/displayName',
      userName: 'user/userName',
      email: 'user/email',
      playerId: 'user/playerId',
      authToken: 'auth/authToken',
      authStatus: 'auth/authStatus',
      playerGameBalanceHALO: 'user/playerGameBalanceHALO',
      playerGameBalanceETH: 'user/playerGameBalanceETH'
    })
  },
  created: function () {
    console.info('playerId: ' + this.playerId)
    /** Listen for a message from Crypto Cage to close the iframe overlay **/
    window.onmessage = function (e) {
      if (e.data === 'closeCryptoCage') {
        var parent = document.body
        var child = document.getElementById('crypto-cage')
        parent.removeChild(child)
      }
    }
  },
  methods: {
    roundBalance (value) {
      if (value < 99) {
        let number = parseFloat(value).toFixed(8)
        return number
      } else {
        let number = parseInt(value)
        return number
      }
    },
    copyAddress () {
      let copyText = document.querySelector('#wallet-address')
      copyText.select()
      document.execCommand('copy')
    },
    openCryptoCage () {
      const iframe = document.createElement("IFRAME")
      iframe.setAttribute("src", process.env.VUE_APP_URL_CAGE)
      // iframe.setAttribute("src", "http://localhost:8081")
      iframe.setAttribute("id", "crypto-cage")
      iframe.style.width = "100%"
      iframe.style.height = "100%"
      iframe.style.position = "absolute"
      iframe.style.top = "0"
      iframe.style.left = "0"
      iframe.style.border = "0"
      document.body.appendChild(iframe)
      this.sendPlayerInfoToCryptoCage()
    },
    /** Send a message to Crypto Cage with the auth token **/
    sendPlayerInfoToCryptoCage () {
      const playerId = this.playerId
      const targetWindow = document.getElementById('crypto-cage')
      targetWindow.onload = function () {
        const authToken = localStorage.token
        targetWindow.contentWindow.postMessage({
          event_id: 'incomingPlayerInfo',
          authToken: authToken,
          playerId: playerId
        }, '*')
      }
    },
    addCommasAddThreeDecs (value) {
      if (!value) return ''
      let number = value.toString().match(/^-?\d+(?:\.\d{0,3})?/)[0]
      let parts = number.split('.')
      parts[0] = parts[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, ',')
      return parts.join('.')
    }
  }
}
</script>

<style scoped>

</style>
